import { Link } from 'react-router-dom';

// Placeholder landing page. Per conventions/frontend-patterns.md, navigation
// uses <Link> (not <button onClick={navigate}>) and interactive elements carry
// a data-testid so regression selectors match.
export default function ComingSoonPage() {
  return (
    <main className="coming-soon" data-testid="coming-soon-page">
      <section className="coming-soon__card">
        <h1 className="coming-soon__title">Hello World DAO</h1>
        <p className="coming-soon__subtitle">Coming soon</p>
        <p className="coming-soon__body">
          We&apos;re building Hello World DAO sign-up. Check back soon.
        </p>
        <Link
          to="/"
          className="coming-soon__link"
          data-testid="coming-soon-home-link"
        >
          Refresh
        </Link>
      </section>
    </main>
  );
}
